import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import LandingPage from "@/pages/LandingPage";
import DashboardPage from "@/pages/DashboardPage";
import PlanPage from "@/pages/PlanPage";
import CheckInPage from "@/pages/CheckInPage";
import ToolkitPage from "@/pages/ToolkitPage";
import CoachPage from "@/pages/CoachPage";
import CrisisPage from "@/pages/CrisisPage";
import TrackerPage from "@/pages/TrackerPage";
import StrategyPage from "@/pages/StrategyPage";
import JourneyPage from "@/pages/JourneyPage";
import VersesPage from "@/pages/VersesPage";
import MembershipPage from "@/pages/MembershipPage";
import MissionPage from "@/pages/MissionPage";
import PrayerWallPage from "@/pages/PrayerWallPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import BlogListPage from "@/pages/BlogListPage";
import BlogPostPage from "@/pages/BlogPostPage";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="journey" element={<JourneyPage />} />
        <Route path="plan" element={<PlanPage />} />
        <Route path="strategy" element={<StrategyPage />} />
        <Route path="tracker" element={<TrackerPage />} />
        <Route path="check-in" element={<CheckInPage />} />
        <Route path="toolkit" element={<ToolkitPage />} />
        <Route path="coach" element={<CoachPage />} />
        <Route path="verses" element={<VersesPage />} />
        <Route path="membership" element={<MembershipPage />} />
        <Route path="mission" element={<MissionPage />} />
        <Route path="together" element={<PrayerWallPage />} />
        <Route path="crisis" element={<CrisisPage />} />
      </Route>
      <Route path="/blog" element={<BlogListPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
